import { client } from '@/sanity/lib/client';
import imageUrlBuilder from '@sanity/image-url';

import IImage from '../interfaces/imageiInterface';

// Билдер не зависит от картинки — создаём один раз на модуль, а не на каждый вызов
const builder = imageUrlBuilder(client);

// Sanity кодирует реальные размеры картинки прямо в _ref: image-<id>-<W>x<H>-<format>
const getImageDimensions = (ref?: string): { width: number; height: number } | undefined => {
    if (!ref) return undefined;
    const match = /-(\d+)x(\d+)-/.exec(ref);
    if (!match) return undefined;
    return { width: Number(match[1]), height: Number(match[2]) };
};

const imageHelper = (imageInfo: any): IImage => {
    const dimensions = getImageDimensions(imageInfo?.asset?._ref);
    return {
        url: builder.image(imageInfo.asset._ref).url(),
        alt: imageInfo.alt,
        width: dimensions?.width,
        height: dimensions?.height,
    };
};

export default imageHelper;
